(function () {
  'use strict';

  var records = new Map();
  var controllerConfig = {
    enabled: false,
    desktopBreakpoint: 768,
    pageProfile: 'default'
  };
  var rebuildTimer = 0;
  var resizeTicking = false;
  var resizeRebuildTimer = 0;
  var lastDesktopMode = null;
  var deferTransitionsUntilTop = false;

  var MANAGED_TYPE_PROFILES = {
    default: {
      'logo-reveal': {
        readyEnterAt: 0.6,
        readyExitAt: 0.52,
        pinPrevious: true,
        forceStageFill: true,
        adapterKey: 'logo-reveal'
      },
      'partner-company': {
        readyEnterAt: 0.6,
        readyExitAt: 0.52,
        pinPrevious: true,
        forceStageFill: true,
        adapterKey: 'partner-company'
      },
      'daily-team': {
        readyEnterAt: 0.6,
        readyExitAt: 0.52,
        pinPrevious: true,
        forceStageFill: true,
        adapterKey: 'daily-team'
      },
      'photo-wall': {
        readyEnterAt: 0.5,
        readyExitAt: 0.42,
        pinPrevious: true,
        forceStageFill: true,
        adapterKey: 'photo-wall'
      },
      'email-ask': {
        readyEnterAt: 0.6,
        readyExitAt: 0.52,
        pinPrevious: true,
        forceStageFill: true,
        adapterKey: 'email-ask'
      },
      'building-contact': {
        readyEnterAt: 0.6,
        readyExitAt: 0.52,
        pinPrevious: true,
        forceStageFill: true,
        adapterKey: 'default'
      },
      'fixed-image-accordion': {
        readyEnterAt: 0.6,
        readyExitAt: 0.52,
        pinPrevious: true,
        forceStageFill: true,
        adapterKey: 'fixed-image-accordion'
      },
      'image-text-grid': {
        readyEnterAt: 0.6,
        readyExitAt: 0.52,
        pinPrevious: true,
        forceStageFill: false,
        keepInDocumentFlow: true,
        adapterKey: 'image-text-grid'
      },
      'image-text-block': {
        readyEnterAt: 0.6,
        readyExitAt: 0.52,
        pinPrevious: true,
        forceStageFill: false,
        keepInDocumentFlow: true,
        adapterKey: 'image-text-block'
      }
    },
    'team-building': null,
    'case-studies': {
      'case-display': {
        readyEnterAt: 0.72,
        readyExitAt: 0.64,
        pinPrevious: true,
        forceStageFill: true,
        startViewportRatio: 0.18,
        adapterKey: 'case-display'
      }
    }
  };

  MANAGED_TYPE_PROFILES['team-building'] = MANAGED_TYPE_PROFILES.default;

  function getManagedTypes() {
    return MANAGED_TYPE_PROFILES[controllerConfig.pageProfile] || MANAGED_TYPE_PROFILES.default;
  }

  function emitTransitionEvent(target, eventName, detail) {
    if (!target) return;
    target.dispatchEvent(new CustomEvent(eventName, {
      bubbles: false,
      detail: detail || {}
    }));
  }

  function noop() { }

  var ADAPTERS = {
    default: {
      freeze: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-freeze', detail);
      },
      commit: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-commit', detail);
      },
      reset: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-reset', detail);
      },
      destroy: noop
    },
    'logo-reveal': {
      freeze: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-freeze', detail);
      },
      commit: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-commit', detail);
      },
      reset: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-reset', detail);
      },
      destroy: noop
    },
    'photo-wall': {
      freeze: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-freeze', detail);
      },
      commit: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-commit', detail);
      },
      reset: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-reset', detail);
      },
      destroy: noop
    },
    'email-ask': {
      freeze: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-freeze', detail);
      },
      commit: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-commit', detail);
      },
      reset: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-reset', detail);
      },
      destroy: noop
    },
    'case-display': {
      freeze: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-freeze', detail);
      },
      commit: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-commit', detail);
      },
      reset: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-reset', detail);
      },
      destroy: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-destroy', detail);
      }
    },
    'partner-company': {
      freeze: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-freeze', detail);
      },
      commit: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-commit', detail);
      },
      reset: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-reset', detail);
      },
      destroy: noop
    },
    'daily-team': {
      freeze: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-freeze', detail);
      },
      commit: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-commit', detail);
      },
      reset: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-reset', detail);
      },
      destroy: noop
    },
    'fixed-image-accordion': {
      freeze: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-freeze', detail);
      },
      commit: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-commit', detail);
      },
      reset: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-reset', detail);
      },
      destroy: noop
    },
    'image-text-grid': {
      freeze: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-freeze', detail);
      },
      commit: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-commit', detail);
      },
      reset: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-reset', detail);
      },
      destroy: noop
    },
    'image-text-block': {
      freeze: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-freeze', detail);
      },
      commit: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-commit', detail);
      },
      reset: function (target, detail) {
        emitTransitionEvent(target, 'mt:page-transition-reset', detail);
      },
      destroy: noop
    }
  };

  function readControllerConfig() {
    var controller = document.querySelector('[data-mt-page-transition-controller]');
    if (!controller) {
      controllerConfig.enabled = false;
      controllerConfig.desktopBreakpoint = 768;
      return;
    }

    controllerConfig.enabled = controller.dataset.enabled === 'true';
    controllerConfig.desktopBreakpoint = parseInt(controller.dataset.desktopBreakpoint || '768', 10) || 768;
    controllerConfig.pageProfile = controller.dataset.pageProfile || 'default';
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function easeOutCubic(value) {
    return 1 - Math.pow(1 - clamp(value, 0, 1), 3);
  }

  function resolveVisibleCoveragePercent(progress) {
    var clamped = clamp(progress, 0, 1);
    if (clamped <= 0) return 0;
    if (clamped >= 1) return 100;

    var minimumVisible = 5;
    var linearCoverage = clamped * 100;
    return Math.max(minimumVisible, linearCoverage);
  }

  function isDesktop() {
    return window.innerWidth >= controllerConfig.desktopBreakpoint;
  }

  function isFeatureEnabled() {
    return controllerConfig.enabled && isDesktop();
  }

  function getTopActivationThreshold() {
    return Math.max(getHeaderOffset(), 24);
  }

  function shouldUseDeferredEntryMode() {
    if (controllerConfig.pageProfile !== 'case-studies' && controllerConfig.pageProfile !== 'team-building') return false;
    return window.scrollY > getTopActivationThreshold();
  }

  function handleDeferredEntryScroll() {
    if (!deferTransitionsUntilTop) return;
    if (window.scrollY > getTopActivationThreshold()) return;

    deferTransitionsUntilTop = false;
    scheduleRebuild();
  }

  function getHeaderOffset() {
    var root = document.documentElement;
    var raw = parseFloat(getComputedStyle(root).getPropertyValue('--mt-top-nav-height'));
    if (!isNaN(raw) && raw > 0) return raw;

    var nav = document.querySelector('.mt-top-nav__wrapper');
    return nav ? nav.getBoundingClientRect().height : 0;
  }

  function resolveTarget(el) {
    if (!el) return null;
    if (records.has(el)) return el;
    return el.closest('[data-mt-transition-enabled]');
  }

  function getTypeConfig(target) {
    if (!target) return null;
    return getManagedTypes()[target.dataset.mtTransitionType || ''] || null;
  }

  function shouldManageTarget(target) {
    return !!getTypeConfig(target);
  }

  function isRenderableElement(node) {
    if (!node || !node.isConnected || node.hidden) return false;

    var style = getComputedStyle(node);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    return true;
  }

  function emitReadyEvent(target, eventName) {
    if (!target) return;
    target.dispatchEvent(new CustomEvent(eventName, {
      bubbles: false
    }));
  }

  function cancelPendingReset(record) {
    if (!record || !record.pendingResetTimer) return;
    window.clearTimeout(record.pendingResetTimer);
    record.pendingResetTimer = 0;
  }

  function cancelPendingFlowRelease(record) {
    if (!record || !record.pendingFlowReleaseTimer) return;
    window.clearTimeout(record.pendingFlowReleaseTimer);
    record.pendingFlowReleaseTimer = 0;
  }

  function getAdapterForTarget(target) {
    var typeConfig = getTypeConfig(target);
    var key = typeConfig && typeConfig.adapterKey ? typeConfig.adapterKey : 'default';
    return ADAPTERS[key] || ADAPTERS.default;
  }

  function callAdapter(record, hookName, detail) {
    if (!record || !record.adapter || typeof record.adapter[hookName] !== 'function') return;
    record.adapter[hookName](record.target, detail || {}, record);
  }

  function measureSectionHeight(record) {
    var candidates = [
      record.target ? record.target.scrollHeight : 0,
      record.shopifySection ? record.shopifySection.scrollHeight : 0,
      record.target ? record.target.getBoundingClientRect().height : 0,
      record.shopifySection ? record.shopifySection.getBoundingClientRect().height : 0,
      window.innerHeight || 0
    ];

    if (record.target) {
      var accordion = record.target.querySelector('.fixed-image-accordion');
      if (accordion) {
        candidates.push(accordion.offsetHeight || 0, accordion.scrollHeight || 0);
      }

      var flowRoot = record.target.querySelector('.mt-image-text-block, .mt-image-text-grid');
      if (flowRoot) {
        candidates.push(flowRoot.offsetHeight || 0, flowRoot.scrollHeight || 0);
      }
    }

    return Math.max.apply(Math, candidates);
  }

  function findPreviousSection(shopifySection) {
    var node = shopifySection ? shopifySection.previousElementSibling : null;

    function findSectionInsideTransitionWrapper(wrapper) {
      if (!wrapper) return null;

      var stageSection = wrapper.querySelector('.mt-page-transition__stage > [id^="shopify-section-"]');
      if (isRenderableElement(stageSection)) return stageSection;

      var anchorSection = wrapper.querySelector('.mt-page-transition__anchor > [id^="shopify-section-"]');
      if (isRenderableElement(anchorSection)) return anchorSection;

      return null;
    }

    while (node) {
      if (node.hasAttribute && node.hasAttribute('data-mt-transition')) {
        var wrappedSection = findSectionInsideTransitionWrapper(node);
        if (wrappedSection) {
          return wrappedSection;
        }
      }

      if (
        node.id &&
        node.id.indexOf('shopify-section-') === 0 &&
        !node.querySelector('[data-mt-page-transition-controller]') &&
        isRenderableElement(node)
      ) {
        return node;
      }
      node = node.previousElementSibling;
    }
    return null;
  }

  function isTransparentColor(value) {
    if (!value) return true;
    var normalized = String(value).trim().toLowerCase();
    return normalized === 'transparent' || normalized === 'rgba(0, 0, 0, 0)' || normalized === 'rgba(0,0,0,0)';
  }

  function resolveBackgroundToken(node, token) {
    if (!node || !token) return '';
    var value = getComputedStyle(node).getPropertyValue(token);
    return value ? value.trim() : '';
  }

  function resolveBackgroundColor(record) {
    var candidates = [
      record.target ? record.target.querySelector('.mt-reveal__content') : null,
      record.target ? record.target.querySelector('.mt-reveal') : null,
      record.target,
      record.shopifySection
    ];

    for (var i = 0; i < candidates.length; i += 1) {
      var node = candidates[i];
      if (!node) continue;

      var tokenColor = resolveBackgroundToken(node, '--mt-reveal-bg-color') ||
        resolveBackgroundToken(node, '--mt-cb-bg') ||
        resolveBackgroundToken(node, '--pw-overlay-color') ||
        resolveBackgroundToken(node, '--mt-email-ask-bg');

      if (!isTransparentColor(tokenColor)) {
        return tokenColor;
      }

      var computedColor = getComputedStyle(node).backgroundColor;
      if (!isTransparentColor(computedColor)) {
        return computedColor;
      }
    }

    return '#ffffff';
  }

  function syncStageBackground(record) {
    var color = resolveBackgroundColor(record);
    record.wrapper.style.setProperty('--mt-page-transition-bg', color);
    record.stage.style.backgroundColor = color;
  }

  function copyBannerVisualVars(source, clone) {
    if (!source || !clone) return;
    var computed = getComputedStyle(source);
    [
      '--mt-cb-bg',
      '--mt-cb-overlay',
      '--mt-cb-title1-color',
      '--mt-cb-title2-color',
      '--mt-cb-subtitle-color',
      '--mt-cb-btn-bg',
      '--mt-cb-btn-color',
      '--mt-cb-scroll-color',
      '--mt-cb-title-min-size',
      '--mt-cb-scroll-bottom-mobile',
      '--mt-cb-stagger-step'
    ].forEach(function (token) {
      var value = computed.getPropertyValue(token);
      if (value) {
        clone.style.setProperty(token, value.trim());
      }
    });
  }

  function collectVisualNodes(root) {
    if (!root) return [];
    return [root].concat(Array.from(root.querySelectorAll('*')).filter(function (node) {
      return node.tagName !== 'SCRIPT' && node.tagName !== 'STYLE';
    }));
  }

  function snapshotVisualState(sourceRoot, cloneRoot) {
    var sourceNodes = collectVisualNodes(sourceRoot);
    var cloneNodes = collectVisualNodes(cloneRoot);
    var count = Math.min(sourceNodes.length, cloneNodes.length);

    for (var i = 0; i < count; i += 1) {
      var sourceNode = sourceNodes[i];
      var cloneNode = cloneNodes[i];
      var computed = getComputedStyle(sourceNode);
      var propertyIndex = 0;

      cloneNode.style.animation = 'none';
      cloneNode.style.transition = 'none';
      cloneNode.style.willChange = 'auto';
      cloneNode.style.opacity = computed.opacity;
      cloneNode.style.visibility = computed.visibility;
      cloneNode.style.transform = computed.transform === 'none' ? 'none' : computed.transform;
      cloneNode.style.transformOrigin = computed.transformOrigin;
      cloneNode.style.filter = computed.filter;

      for (propertyIndex = 0; propertyIndex < computed.length; propertyIndex += 1) {
        var propertyName = computed[propertyIndex];
        if (propertyName && propertyName.indexOf('--') === 0) {
          cloneNode.style.setProperty(propertyName, computed.getPropertyValue(propertyName));
        }
      }
    }
  }

  function sanitizeVisualClone(root) {
    if (!root) return root;
    root.setAttribute('aria-hidden', 'true');
    root.setAttribute('inert', '');
    root.style.pointerEvents = 'none';
    root.querySelectorAll('[id]').forEach(function (node) {
      node.removeAttribute('id');
    });
    root.querySelectorAll('[for]').forEach(function (node) {
      node.removeAttribute('for');
    });
    root.querySelectorAll('[aria-labelledby],[aria-describedby],[aria-controls],[aria-owns],[aria-activedescendant],[aria-flowto]').forEach(function (node) {
      node.removeAttribute('aria-labelledby');
      node.removeAttribute('aria-describedby');
      node.removeAttribute('aria-controls');
      node.removeAttribute('aria-owns');
      node.removeAttribute('aria-activedescendant');
      node.removeAttribute('aria-flowto');
    });
    root.querySelectorAll('script, style').forEach(function (node) {
      node.remove();
    });
    return root;
  }

  function findVisualRoot(shopifySection) {
    if (!shopifySection) return null;

    var transitionRoot = shopifySection.querySelector('[data-mt-transition-enabled]');
    if (transitionRoot) return transitionRoot;

    var bannerRoot = shopifySection.querySelector('.mt-case-banner');
    if (bannerRoot) return bannerRoot;

    var child = shopifySection.firstElementChild;
    while (child) {
      var tag = child.tagName;
      if (tag !== 'SCRIPT' && tag !== 'STYLE' && tag !== 'LINK') {
        return child;
      }
      child = child.nextElementSibling;
    }

    return null;
  }

  function findNextManagedSection(shopifySection) {
    var node = shopifySection ? shopifySection.nextElementSibling : null;

    while (node) {
      if (
        node.id &&
        node.id.indexOf('shopify-section-') === 0 &&
        !node.querySelector('[data-mt-page-transition-controller]') &&
        isRenderableElement(node)
      ) {
        var transitionTarget = node.querySelector('[data-mt-transition-enabled="true"]');
        if (isRenderableElement(transitionTarget) && shouldManageTarget(transitionTarget)) {
          return node;
        }
      }
      node = node.nextElementSibling;
    }

    return null;
  }

  function getRecordBySection(shopifySection) {
    if (!shopifySection) return null;

    var matched = null;
    records.forEach(function (record) {
      if (!matched && record.shopifySection === shopifySection) {
        matched = record;
      }
    });

    return matched;
  }

  function createPreviousVisual(record) {
    if (!record.previousShopifySection) return null;

    var sourceRoot = findVisualRoot(record.previousShopifySection);
    if (!sourceRoot) return null;

    var clone = sourceRoot.cloneNode(true);
    clone.classList.add('mt-page-transition__previous-visual');

    if (sourceRoot.classList.contains('mt-case-banner')) {
      copyBannerVisualVars(sourceRoot, clone);
    }

    snapshotVisualState(sourceRoot, clone);
    sanitizeVisualClone(clone);
    return clone;
  }

  function shouldUsePreparedBannerVisual(record) {
    return !!(record && shouldPinSourceFromStart(record));
  }

  function preparePreviousVisual(record) {
    if (!record || !record.previousStage || record.isPreviousInStage) return;
    if (record.preparedPreviousVisual) return;

    var preparedVisual = createPreviousVisual(record);
    if (!preparedVisual) return;

    record.preparedPreviousVisual = preparedVisual;
  }

  function shouldPinSourceFromStart(record) {
    if (!record || record.previousRecord || !record.previousShopifySection) return false;

    var sourceRoot = findVisualRoot(record.previousShopifySection);
    return !!(sourceRoot && sourceRoot.classList && sourceRoot.classList.contains('mt-case-banner'));
  }

  function getBannerIntroDelay(record) {
    if (!record || !record.previousShopifySection) return 0;

    var sourceRoot = findVisualRoot(record.previousShopifySection);
    if (!sourceRoot || !sourceRoot.classList || !sourceRoot.classList.contains('mt-case-banner')) return 0;

    var staggerStep = parseFloat(getComputedStyle(sourceRoot).getPropertyValue('--mt-cb-stagger-step')) || 400;
    var revealNodes = Array.from(sourceRoot.querySelectorAll('[data-mt-cb-reveal]'));
    var maxOrder = revealNodes.reduce(function (max, node) {
      var order = parseFloat(getComputedStyle(node).getPropertyValue('--mt-cb-order')) || 0;
      return Math.max(max, order);
    }, 0);

    return Math.round(maxOrder * staggerStep + 900);
  }

  function syncInitialPinnedSource(record) {
    if (!shouldPinSourceFromStart(record)) return;
    if (record.active || record.committed || record.isInStage) return;
    if (record.pendingInitialPinTimer) return;

    record.pendingInitialPinTimer = window.setTimeout(function () {
      record.pendingInitialPinTimer = 0;
      if (record.active || record.committed || record.isInStage) return;
      preparePreviousVisual(record);
    }, getBannerIntroDelay(record));
  }

  function syncAnchorHeight(record) {
    var height = measureSectionHeight(record);
    record.anchor.style.minHeight = Math.round(height) + 'px';
  }

  function usesDocumentFlowMode(record) {
    return !!(record && record.typeConfig && record.typeConfig.keepInDocumentFlow);
  }

  function clearFlowStageClone(record) {
    if (!record || !record.flowStageClone) return;

    if (record.flowStageClone.parentNode) {
      record.flowStageClone.parentNode.removeChild(record.flowStageClone);
    }

    record.flowStageClone = null;
  }

  function mountFlowStageClone(record) {
    clearFlowStageClone(record);
    if (!record || !record.target || !record.stage) return;

    var clone = record.target.cloneNode(true);
    clone.classList.add('mt-page-transition__flow-clone');
    snapshotVisualState(record.target, clone);
    sanitizeVisualClone(clone);
    record.flowStageClone = clone;
    record.stage.appendChild(clone);
  }

  function restoreDocumentFlowSection(record) {
    if (!record) return;

    clearFlowStageClone(record);
    record.isInStage = false;

    if (record.stage) {
      record.stage.hidden = true;
    }

    if (record.shopifySection) {
      record.shopifySection.classList.remove(
        'mt-page-transition__section--staged',
        'mt-page-transition__section--source-hidden'
      );
      record.shopifySection.style.visibility = '';
    }

    syncAnchorHeight(record);
    hidePreviousVisual(record);
  }

  function commitDocumentFlowSection(record) {
    if (!record) return;

    record.progress = 1;
    record.active = false;
    record.committed = true;
    record.scrollOriginY = window.scrollY;
    setReadyState(record, true);

    if (record.stage) {
      record.stage.style.transform = 'translate3d(0, 0%, 0)';
    }

    restoreDocumentFlowSection(record);
    syncDatasets(record);
    callAdapter(record, 'commit', buildStatePayload(record));
  }

  function resolvePreviousVisualOffset(record) {
    if (!record || !record.previousShopifySection || record.previousRecord) return 0;
    if (typeof record.previousVisualOffsetY === 'number') return record.previousVisualOffsetY;

    var sourceRoot = findVisualRoot(record.previousShopifySection);
    if (!sourceRoot || !sourceRoot.classList || !sourceRoot.classList.contains('mt-case-banner')) {
      return 0;
    }

    if (controllerConfig.pageProfile === 'case-studies' || controllerConfig.pageProfile === 'team-building') {
      return Math.round(sourceRoot.getBoundingClientRect().top);
    }

    return 0;
  }

  function showPreviousVisual(record) {
    if (!record.previousStage || !record.previousShopifySection || record.isPreviousInStage) return;
    if (shouldUsePreparedBannerVisual(record) && !record.sourceVisualCanShow) {
      preparePreviousVisual(record);
      return;
    }

    var previousOffsetY = resolvePreviousVisualOffset(record);
    record.previousVisualOffsetY = previousOffsetY;

    if (shouldUsePreparedBannerVisual(record) && record.preparedPreviousVisual) {
      record.previousVisual = record.preparedPreviousVisual;
      record.preparedPreviousVisual = null;
    } else {
      record.previousVisual = createPreviousVisual(record);
    }

    if (!record.previousVisual) return;

    record.previousStage.replaceChildren(record.previousVisual);
    record.previousStage.hidden = false;
    record.previousStage.style.transform = previousOffsetY
      ? 'translate3d(0, ' + previousOffsetY + 'px, 0)'
      : '';
    record.isPreviousInStage = true;
    record.previousShopifySection.classList.add('mt-page-transition__section--source-hidden');
    record.previousShopifySection.style.visibility = 'hidden';
  }

  function hidePreviousVisual(record) {
    if (!record.previousStage || !record.isPreviousInStage) return;

    if (record.pendingHideFrame) {
      cancelAnimationFrame(record.pendingHideFrame);
      record.pendingHideFrame = 0;
    }

    record.previousStage.hidden = true;
    record.previousStage.style.transform = '';
    record.previousStage.replaceChildren();
    record.previousVisual = null;
    record.isPreviousInStage = false;

    if (record.previousShopifySection) {
      record.previousShopifySection.style.visibility = '';
      record.previousShopifySection.classList.remove('mt-page-transition__section--source-hidden');
    }
  }

  function mountToStage(record) {
    if (record.isInStage) return;
    if (record.pendingInitialPinTimer) {
      window.clearTimeout(record.pendingInitialPinTimer);
      record.pendingInitialPinTimer = 0;
    }
    syncAnchorHeight(record);
    syncStageBackground(record);
    if (!usesPreviousStageHandoff(record)) {
      showPreviousVisual(record);
    }

    if (usesDocumentFlowMode(record)) {
      mountFlowStageClone(record);
      record.isInStage = true;
      record.stage.hidden = false;
      record.shopifySection.classList.add('mt-page-transition__section--staged');
      record.shopifySection.classList.add('mt-page-transition__section--source-hidden');
      record.shopifySection.style.visibility = 'hidden';
      return;
    }

    record.stage.appendChild(record.shopifySection);
    record.isInStage = true;
    record.stage.hidden = false;
    record.shopifySection.classList.add('mt-page-transition__section--staged');
  }

  function mountToAnchor(record) {
    if (record.pendingInitialPinTimer) {
      window.clearTimeout(record.pendingInitialPinTimer);
      record.pendingInitialPinTimer = 0;
    }

    if (usesDocumentFlowMode(record)) {
      restoreDocumentFlowSection(record);
      return;
    }

    if (!record.isInStage && record.shopifySection.parentNode === record.anchor) {
      if (!record.isPreviousInStage) return;
    }

    record.anchor.appendChild(record.shopifySection);
    record.isInStage = false;
    record.stage.hidden = true;
    record.shopifySection.classList.remove('mt-page-transition__section--staged');
    hidePreviousVisual(record);
    syncAnchorHeight(record);
  }

  function releaseCommittedPreviousRecord(record) {
    if (!record || !record.previousRecord) return;

    var previousRecord = record.previousRecord;
    if (!previousRecord.committed) return;

    if (usesDocumentFlowMode(previousRecord)) {
      if (previousRecord.isInStage || previousRecord.flowStageClone) {
        restoreDocumentFlowSection(previousRecord);
        syncDatasets(previousRecord);
      }
      return;
    }

    if (!previousRecord.isInStage) return;

    mountToAnchor(previousRecord);
    syncDatasets(previousRecord);
  }

  function releaseCommittedAncestorRecord(record) {
    if (!record || !record.previousRecord || !record.previousRecord.previousRecord) return;

    var ancestorRecord = record.previousRecord.previousRecord;
    if (!ancestorRecord.committed || !ancestorRecord.isInStage) return;

    mountToAnchor(ancestorRecord);
    syncDatasets(ancestorRecord);
  }

  function usesPreviousStageHandoff(record) {
    return !!(record && record.previousRecord && record.previousRecord.committed);
  }

  function shouldExitToFlow(record) {
    return !!(record && !record.nextManagedShopifySection);
  }

  function ensurePreviousStageHandoff(record) {
    if (!usesPreviousStageHandoff(record)) return;

    var previousRecord = record.previousRecord;

    if (usesDocumentFlowMode(previousRecord)) {
      restoreDocumentFlowSection(previousRecord);
      previousRecord.active = false;
      previousRecord.committed = true;
      if (previousRecord.stage) {
        previousRecord.stage.style.transform = 'translate3d(0, 0%, 0)';
      }
      syncDatasets(previousRecord);
      return;
    }

    if (!previousRecord.isInStage) {
      mountToStage(previousRecord);
    }

    previousRecord.active = false;
    previousRecord.committed = true;
    previousRecord.stage.style.transform = 'translate3d(0, 0%, 0)';
    syncDatasets(previousRecord);
  }

  function syncDatasets(record) {
    record.wrapper.dataset.transitionProgress = record.progress.toFixed(4);
    record.wrapper.dataset.transitionActive = record.active ? 'true' : 'false';
    record.wrapper.dataset.transitionReady = record.ready ? 'true' : 'false';
    record.wrapper.dataset.transitionCommitted = record.committed ? 'true' : 'false';
  }

  function updateReadyState(record, progress) {
    if (record.ready) {
      return progress > record.readyExitThreshold;
    }
    return progress >= record.readyEnterThreshold;
  }

  var INTERACTIVE_WHEN_READY_TYPES = {
    'building-contact': true,
    'case-display': true,
    'image-text-block': true,
    'image-text-grid': true,
    'photo-wall': true,
    'email-ask': true
  };

  function setReadyState(record, ready) {
    if (ready === record.ready) return;
    record.ready = ready;

    if (INTERACTIVE_WHEN_READY_TYPES[record.type]) {
      record.shopifySection.classList.toggle('mt-page-transition__section--interactive', ready);
    }

    if (ready) {
      emitReadyEvent(record.target, 'mt:page-transition-ready');
    } else {
      emitReadyEvent(record.target, 'mt:page-transition-unready');
    }
  }

  function buildStatePayload(record, overrides) {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    var scrollSpanSource = record.anchor ? record.anchor.offsetHeight : 0;
    var payload = {
      enabled: isFeatureEnabled(),
      type: record.type,
      active: record.active,
      progress: record.progress,
      ready: record.ready,
      committed: record.committed,
      scrollOriginY: record.scrollOriginY,
      scrollSpanPx: Math.max(scrollSpanSource - viewportHeight, 1)
    };

    if (overrides) {
      Object.keys(overrides).forEach(function (key) {
        payload[key] = overrides[key];
      });
    }

    return payload;
  }

  function resolveEntryVisibleCoverage(record) {
    if (!record || !record.shopifySection) return 0;

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    if (!viewportHeight) return 0;

    var rect = record.shopifySection.getBoundingClientRect();
    var visiblePx = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
    if (!isFinite(visiblePx) || visiblePx <= 0) return 0;

    return clamp((visiblePx / viewportHeight) * 100, 0, 100);
  }

  function shouldUseEntryVisibleCoverage(record) {
    if (!record) return false;
    if (controllerConfig.pageProfile !== 'case-studies') return false;
    if (record.type !== 'case-display') return false;
    if (record.previousRecord) return false;

    var sourceRoot = findVisualRoot(record.previousShopifySection);
    return !!(sourceRoot && sourceRoot.classList && sourceRoot.classList.contains('mt-case-banner'));
  }

  function updateRecord(record, progress) {
    var clamped = clamp(progress, 0, 1);
    var previousProgress = record.progress;
    var active = clamped > 0 && clamped < 1;
    var visibleCoverage = resolveVisibleCoveragePercent(clamped);

    if (controllerConfig.pageProfile === 'case-studies' && record.type === 'case-display' && clamped > 0.75 && clamped < 1) {
      var isReverse = clamped < previousProgress;
      if (!isReverse) {
        var finalWindowProgress = (clamped - 0.75) / 0.25;
        var startCoverage = resolveVisibleCoveragePercent(0.75);
        visibleCoverage = startCoverage + ((100 - startCoverage) * easeOutCubic(finalWindowProgress));
      }
    }

    if (shouldUseEntryVisibleCoverage(record) && record.entryVisibleCoverage > 0 && clamped >= previousProgress) {
      visibleCoverage = record.entryVisibleCoverage + ((100 - record.entryVisibleCoverage) * clamped);
    }

    var translateY = 100 - visibleCoverage;

    record.progress = clamped;
    record.active = active;
    record.committed = false;
    record.scrollOriginY = null;

    setReadyState(record, updateReadyState(record, clamped));
      record.stage.style.transform = 'translate3d(0, ' + translateY.toFixed(3) + '%, 0)';
    syncDatasets(record);
    callAdapter(record, 'freeze', buildStatePayload(record));
  }

  function buildTrigger(record) {
    if (!window.ScrollTrigger) {
      updateRecord(record, 1);
      return;
    }

    record.trigger = window.ScrollTrigger.create({
      trigger: record.wrapper,
      start: function () {
        var startViewportRatio = typeof record.typeConfig.startViewportRatio === 'number'
          ? record.typeConfig.startViewportRatio
          : 0.05;
        var activationOffset = Math.max(getHeaderOffset(), Math.round(window.innerHeight * startViewportRatio));
        return 'top bottom-=' + activationOffset;
      },
      end: function () {
        return 'top top+=' + Math.round(getHeaderOffset());
      },
      scrub: true,
      invalidateOnRefresh: true,
      onRefreshInit: function () {
        syncAnchorHeight(record);
        syncStageBackground(record);
      },
      onEnter: function () {
        cancelPendingReset(record);
        cancelPendingFlowRelease(record);
        record.committed = false;
        record.scrollOriginY = null;
        record.sourceVisualCanShow = true;
        record.entryVisibleCoverage = shouldUseEntryVisibleCoverage(record) ? resolveEntryVisibleCoverage(record) : 0;
        ensurePreviousStageHandoff(record);
        releaseCommittedAncestorRecord(record);
        mountToStage(record);
        syncDatasets(record);
      },
      onEnterBack: function () {
        cancelPendingReset(record);
        cancelPendingFlowRelease(record);
        record.committed = false;
        record.scrollOriginY = null;
        record.sourceVisualCanShow = true;
        record.entryVisibleCoverage = 0;
        ensurePreviousStageHandoff(record);
        releaseCommittedAncestorRecord(record);
        mountToStage(record);
        syncDatasets(record);
      },
      onUpdate: function (self) {
        updateRecord(record, self.progress);
      },
      onLeave: function () {
        cancelPendingReset(record);
        cancelPendingFlowRelease(record);

        if (usesDocumentFlowMode(record)) {
          releaseCommittedPreviousRecord(record);
          commitDocumentFlowSection(record);
          return;
        }

        record.progress = 1;
        record.active = false;
        record.committed = true;
        record.scrollOriginY = window.scrollY;
        setReadyState(record, true);
        record.stage.style.transform = 'translate3d(0, 0%, 0)';
        if (shouldExitToFlow(record)) {
          releaseCommittedPreviousRecord(record);
          record.pendingFlowReleaseTimer = window.setTimeout(function () {
            record.pendingFlowReleaseTimer = 0;
            mountToAnchor(record);
          }, 48);
        }
        syncDatasets(record);
        callAdapter(record, 'commit', buildStatePayload(record));
      },
      onLeaveBack: function () {
        cancelPendingReset(record);
        cancelPendingFlowRelease(record);
        record.progress = 0;
        record.active = false;
        record.committed = false;
        record.scrollOriginY = null;
        setReadyState(record, false);
        record.sourceVisualCanShow = false;
        record.entryVisibleCoverage = 0;
        mountToAnchor(record);
        record.stage.style.transform = 'translate3d(0, 100%, 0)';
        syncDatasets(record);
        record.pendingResetTimer = window.setTimeout(function () {
          record.pendingResetTimer = 0;
          callAdapter(record, 'reset', buildStatePayload(record));
        }, 34);
        record.previousVisualOffsetY = null;
        syncInitialPinnedSource(record);
      }
    });

    record.progress = record.trigger.progress || 0;
    record.active = false;
    record.committed = record.progress >= 1;
    record.scrollOriginY = record.committed ? window.scrollY : null;
    setReadyState(record, record.committed);
    syncDatasets(record);
  }

  function createRecord(target) {
    var shopifySection = target.closest('[id^="shopify-section-"]');
    var typeConfig = getTypeConfig(target);
    var previousShopifySection = findPreviousSection(shopifySection);
    var nextManagedShopifySection = findNextManagedSection(shopifySection);
    var previousRecord = getRecordBySection(previousShopifySection);

    if (!shopifySection || records.has(target) || !typeConfig) return;

    var wrapper = document.createElement('div');
    var anchor = document.createElement('div');
    var previousStage = null;
    var stage = document.createElement('div');
    var parent = shopifySection.parentNode;

    wrapper.className = 'mt-page-transition';
    wrapper.dataset.mtTransition = 'true';
    wrapper.dataset.transitionMode = 'real-stage';
    wrapper.dataset.transitionType = target.dataset.mtTransitionType || 'generic';
    wrapper.dataset.transitionActive = 'false';
    wrapper.dataset.transitionProgress = '0.0000';
    wrapper.dataset.transitionReady = 'false';
    wrapper.dataset.transitionCommitted = 'false';
    wrapper.dataset.transitionForceStageFill = typeConfig.forceStageFill ? 'true' : 'false';

    anchor.className = 'mt-page-transition__anchor';
    if (typeConfig.pinPrevious && previousShopifySection) {
      previousStage = document.createElement('div');
      previousStage.className = 'mt-page-transition__previous-stage';
      previousStage.hidden = true;
      previousStage.setAttribute('aria-hidden', 'true');
    }

    stage.className = 'mt-page-transition__stage';
    stage.hidden = true;
    stage.setAttribute('aria-hidden', 'true');
    stage.dataset.transitionType = wrapper.dataset.transitionType;

    parent.insertBefore(wrapper, shopifySection);
    wrapper.appendChild(anchor);
    if (previousStage) {
      wrapper.appendChild(previousStage);
    }
    wrapper.appendChild(stage);
    anchor.appendChild(shopifySection);

    var record = {
      target: target,
      type: wrapper.dataset.transitionType,
      typeConfig: typeConfig,
      adapter: getAdapterForTarget(target),
      shopifySection: shopifySection,
      previousShopifySection: previousShopifySection,
      nextManagedShopifySection: nextManagedShopifySection,
      previousRecord: previousRecord,
      wrapper: wrapper,
      anchor: anchor,
      previousStage: previousStage,
      previousVisual: null,
      preparedPreviousVisual: null,
      previousVisualOffsetY: null,
      entryVisibleCoverage: 0,
      stage: stage,
      trigger: null,
      progress: 0,
      ready: false,
      active: false,
      committed: false,
      isInStage: false,
      isPreviousInStage: false,
      pendingHideFrame: 0,
      pendingInitialPinTimer: 0,
      pendingResetTimer: 0,
      pendingFlowReleaseTimer: 0,
      sourceVisualCanShow: false,
      flowStageClone: null,
      readyEnterThreshold: typeConfig.readyEnterAt,
      readyExitThreshold: typeConfig.readyExitAt,
      scrollOriginY: null
    };

    if (INTERACTIVE_WHEN_READY_TYPES[record.type]) {
      record.shopifySection.classList.toggle('mt-page-transition__section--interactive', false);
    }

    syncAnchorHeight(record);
    syncStageBackground(record);
    buildTrigger(record);
    syncInitialPinnedSource(record);
    records.set(target, record);
  }

  function destroyRecord(record) {
    if (!record) return;

    if (record.trigger) {
      record.trigger.kill();
      record.trigger = null;
    }

    callAdapter(record, 'destroy', buildStatePayload(record));
    if (record.pendingInitialPinTimer) {
      window.clearTimeout(record.pendingInitialPinTimer);
      record.pendingInitialPinTimer = 0;
    }
    cancelPendingReset(record);
    cancelPendingFlowRelease(record);
    record.sourceVisualCanShow = false;
    record.shopifySection.classList.remove('mt-page-transition__section--interactive');
    record.preparedPreviousVisual = null;
    clearFlowStageClone(record);
    mountToAnchor(record);
    record.anchor.style.minHeight = '';
    hidePreviousVisual(record);

    var parent = record.wrapper.parentNode;
    if (parent) {
      parent.insertBefore(record.shopifySection, record.wrapper);
      record.wrapper.remove();
    }
  }

  function destroyAll() {
    records.forEach(function (record, target) {
      destroyRecord(record);
      records.delete(target);
    });
  }

  function scanTargets() {
    return Array.from(document.querySelectorAll('[data-mt-transition-enabled="true"]')).filter(function (target) {
      return isRenderableElement(target) && shouldManageTarget(target);
    });
  }

  function rebuild() {
    readControllerConfig();
    var desktopMode = isDesktop();

    if (!isFeatureEnabled()) {
      destroyAll();
      deferTransitionsUntilTop = false;
      lastDesktopMode = desktopMode;
      return;
    }

    if (shouldUseDeferredEntryMode()) {
      destroyAll();
      deferTransitionsUntilTop = true;
      lastDesktopMode = desktopMode;
      return;
    }

    deferTransitionsUntilTop = false;
    destroyAll();
    scanTargets().forEach(createRecord);

    if (window.ScrollTrigger) {
      window.ScrollTrigger.refresh();
    }

    lastDesktopMode = desktopMode;
  }

  function scheduleRebuild() {
    window.clearTimeout(rebuildTimer);
    rebuildTimer = window.setTimeout(rebuild, 40);
  }

  function handleResize() {
    if (resizeTicking) return;
    resizeTicking = true;
    requestAnimationFrame(function () {
      resizeTicking = false;
      readControllerConfig();
      window.clearTimeout(resizeRebuildTimer);
      resizeRebuildTimer = window.setTimeout(function () {
        resizeRebuildTimer = 0;
        rebuild();
      }, 120);
    });
  }

  window.MTPageTransition = {
    isEnabled: function () {
      readControllerConfig();
      return isFeatureEnabled();
    },
    isReady: function (el) {
      var target = resolveTarget(el);
      if (!target) return true;

      var record = records.get(target);
      return record ? record.ready : true;
    },
    getState: function (el) {
      var target = resolveTarget(el);
      var record = target ? records.get(target) : null;

      if (!record) {
        return {
          enabled: this.isEnabled(),
          active: false,
          progress: 1,
          ready: true,
          committed: true,
          scrollOriginY: null
        };
      }

      return buildStatePayload(record);
    },
    rebuild: rebuild
  };

  function init() {
    scheduleRebuild();
    window.addEventListener('load', scheduleRebuild);
    window.addEventListener('pageshow', function (event) {
      if (event && event.persisted) {
        scheduleRebuild();
      }
    });
    document.addEventListener('shopify:section:load', scheduleRebuild);
    document.addEventListener('shopify:section:unload', scheduleRebuild);
    document.addEventListener('shopify:section:reorder', scheduleRebuild);
    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleDeferredEntryScroll, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleResize);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
